const routes = {
   authLogin:'/auth/login',
   generateSession:'/generateSession',
   authLoginViaEmail:'/auth/loginViaEmail',
   authRegisterViaEmail:'/auth/register',
   SendOtp:'users/changePassword',
   authVendorRegisterViaEmail:'/vendors/register'
};

export default routes